const validLifeStyleSectionMSIDsForShopTheLook = [
  '64732371', //food
  '2886714', //healthfitness
  '2886713', //relationship
  '2886715', //fashion
  '65839708', //parenting
  '5912641', //home_garden
  '2886724', //beauty
];

export default validLifeStyleSectionMSIDsForShopTheLook;
